import React, { useState } from "react";
import { Button, Layout, Menu, Space, Typography } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { ApiOutlined, TagsOutlined, TeamOutlined, FileSearchOutlined, LogoutOutlined } from "@ant-design/icons";

const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const menuItems = [
  { label: "카드 등록", key: "tags", icon: <TagsOutlined /> },
  { label: "반/학생", key: "classes", icon: <TeamOutlined /> },
  { label: "판독 기록", key: "records", icon: <FileSearchOutlined /> },
  { label: "리더 설정", key: "readers", icon: <ApiOutlined /> },
];

const AdminLayout = ({ auth, logout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const currentMenuKey = menuItems.find((item) => location.pathname.includes(item.key))?.key || "tags";
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={{ color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
        <div style={{ fontSize: 20, fontWeight: 700 }}>School Run · UHF RFID</div>
        <Space>
          <Text style={{ color: "rgba(255,255,255,0.85)" }}>{auth?.user_name ? `${auth.user_name} · ` : ""}1회 {Number(auth?.length || 0)}m</Text>
          <Button size="small" icon={<LogoutOutlined />} onClick={logout}>로그아웃</Button>
        </Space>
      </Header>
      <Layout>
        <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} theme="dark">
          <Menu theme="dark" mode="inline" selectedKeys={[currentMenuKey]} items={menuItems} onClick={({ key }) => navigate(`/${key}`)} />
        </Sider>
        <Content style={{ padding: 24, background: "#f5f5f5", overflow: "auto" }}>
          <div style={{ background: "#fff", borderRadius: 12, padding: 24, minHeight: "calc(100vh - 112px)" }}><Outlet /></div>
        </Content>
      </Layout>
    </Layout>
  );
};
export default AdminLayout;
